import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import Navbar from '../../Components/Navbar';
import './Upload.css';

const Upload = () => {
  const navigate = useNavigate();
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercentage((prev) => {
        if (prev === 100) {
          clearInterval(interval);
          setTimeout(() => {
            navigate("/Score"); 
          }, 500);
          return 100;
        }
        return prev + 1;
      });
    }, 50);

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="main">
      <Navbar />
      <div className="upload-container">
        <div className="upload-box">
          <h1>Uploading Your Contracts</h1>
          <h6>This may take a while</h6>
          <div className="progress-circle" style={{ '--percentage': `${percentage}%` }}>
            <span className="progress-text">{percentage}%</span>
            <div className="progress-circle" style={{ '--percentage': `${percentage}%` }}>
            <span className="progress-text">{percentage}%</span>
          </div>
          </div>
        </div>
      </div>
     </div>
  );
};

export default Upload;
